import React, { useState } from "react";
import { Switch, FormControlLabel, Stack } from "@mui/material";
import { StorageUtil } from "utils";
import { KeyConstant } from "const";

const TestFailed = () => {
  const [uploadFileFail, setUploadFileFail] = useState(
    StorageUtil.getCommonKey(KeyConstant.KEY_UPLOAD_FILE_FAIL) || false,
  );
  const [encryptFileFail, setEncryptFileFail] = useState(
    StorageUtil.getCommonKey(KeyConstant.KEY_ENCRYPT_FILE_FAIL) || false,
  );
  const [sendMessageFail, setSendMessageFail] = useState(
    StorageUtil.getCommonKey(KeyConstant.KEY_SEND_MESSAGE_FAIL) || false,
  );
  const [downloadFileFail, setDownloadFileFail] = useState(
    StorageUtil.getCommonKey(KeyConstant.KEY_DOWNLOAD_FILE_FAIL) || false,
  );
  const [decryptFileFail, setDecryptFileFail] = useState(
    StorageUtil.getCommonKey(KeyConstant.KEY_DECRYPT_FILE_FAIL) || false,
  );

  const [resetSession, setResetSession] = useState(StorageUtil.getCommonKey(KeyConstant.KEY_RESET_SESSION) || false);

  const [ignoreFistSender, setIgnoreFistSender] = useState(
    StorageUtil.getCommonKey(KeyConstant.KEY_IGNORE_FIRST_SENDER) || false,
  );

  const handleToggle = (key, value, setter) => {
    StorageUtil.setCommonKey(key, value);
    setter(value);
  };

  return (
    <Stack spacing={2}>
      <FormControlLabel
        control={
          <Switch
            checked={uploadFileFail}
            onChange={e => handleToggle(KeyConstant.KEY_UPLOAD_FILE_FAIL, e.target.checked, setUploadFileFail)}
          />
        }
        label="Upload File Fail"
      />
      <FormControlLabel
        control={
          <Switch
            checked={encryptFileFail}
            onChange={e => handleToggle(KeyConstant.KEY_ENCRYPT_FILE_FAIL, e.target.checked, setEncryptFileFail)}
          />
        }
        label="Encrypt File Fail"
      />
      <FormControlLabel
        control={
          <Switch
            checked={sendMessageFail}
            onChange={e => handleToggle(KeyConstant.KEY_SEND_MESSAGE_FAIL, e.target.checked, setSendMessageFail)}
          />
        }
        label="Send Message Fail"
      />
      <FormControlLabel
        control={
          <Switch
            checked={downloadFileFail}
            onChange={e => handleToggle(KeyConstant.KEY_DOWNLOAD_FILE_FAIL, e.target.checked, setDownloadFileFail)}
          />
        }
        label="Download File Fail"
      />
      <FormControlLabel
        control={
          <Switch
            checked={decryptFileFail}
            onChange={e => handleToggle(KeyConstant.KEY_DECRYPT_FILE_FAIL, e.target.checked, setDecryptFileFail)}
          />
        }
        label="Decrypt File Fail"
      />
      <FormControlLabel
        control={
          <Switch
            checked={resetSession}
            onChange={e => handleToggle(KeyConstant.KEY_RESET_SESSION, e.target.checked, setResetSession)}
          />
        }
        label="Reset Session"
      />

      <FormControlLabel
        control={
          <Switch
            checked={ignoreFistSender}
            onChange={e => handleToggle(KeyConstant.KEY_IGNORE_FIRST_SENDER, e.target.checked, setIgnoreFistSender)}
          />
        }
        label="IGNORE FIRST SENDER"
      />
    </Stack>
  );
};

export default TestFailed;
